var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicQualityImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 11.6667C11.8837 11.6667 12.992 10.55 12.992 9.16669L13.0003 4.16669C13.0003 2.78335 11.8837 1.66669 10.5003 1.66669C9.11699 1.66669 8.00033 2.78335 8.00033 4.16669V9.16669C8.00033 10.55 9.11699 11.6667 10.5003 11.6667ZM9.50033 4.08335C9.50033 3.53335 9.95033 3.08335 10.5003 3.08335C11.0503 3.08335 11.5003 3.53335 11.5003 4.08335L11.492 9.25002C11.492 9.80002 11.0503 10.25 10.5003 10.25C9.95033 10.25 9.50033 9.80002 9.50033 9.25002V4.08335ZM14.917 9.16669C14.917 11.6667 12.8003 13.4167 10.5003 13.4167C8.20033 13.4167 6.08366 11.6667 6.08366 9.16669H4.66699C4.66699 12.0084 6.93366 14.3584 9.66699 14.7667V17.5H11.3337V14.7667C14.067 14.3667 16.3337 12.0167 16.3337 9.16669H14.917Z",
    fill: "#A2C357"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0889 3.01247C11.0889 2.21352 11.4063 1.44728 11.9712 0.882333C12.5361 0.317385 13.3024 0 14.1013 0C14.9003 0 15.6665 0.317385 16.2315 0.882333C16.7964 1.44728 17.1138 2.21352 17.1138 3.01247C17.1138 3.81143 16.7964 4.57767 16.2315 5.14262C15.6665 5.70756 14.9003 6.02495 14.1013 6.02495C13.3024 6.02495 12.5361 5.70756 11.9712 5.14262C11.4063 4.57767 11.0889 3.81143 11.0889 3.01247ZM13.9294 4.30181L15.6638 2.13364L15.3505 1.883L13.8716 3.73105L12.8241 2.85824L12.567 3.16671L13.9294 4.30181Z",
    fill: "#A2C357"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_4209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.02495,
    height: 6.02495,
    fill: "white",
    transform: "translate(11.0889)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicQualityImg);
export default __webpack_public_path__ + "static/media/mic_quality_img.a4249b2c197886749a8cc9e68b168c95.svg";
export { ForwardRef as ReactComponent };